import XWAvatarMessage from "../../components/XWAvatarMessage";

export const HomePage = () => {

  return(
    <XWAvatarMessage message={`Under construction...`} />
  );
};

export default HomePage;